module.exports = __webpack_public_path__ + "img/页面3-2.eaa348a5.png";